/**
 * 限制input输入框格式 比如只能是数字、数字或字母等
 * input有自带type="number" 但样式比较丑、并且可以输入负数
 * 使用方法：校验数字或小数 <el-input v-model="create.totalVolume" v-limit-input="{reg: /[^0-9\.]/}"></el-input>
 * → v-limit-input="{reg: /[^0-9\.]/}
 */
const inputDirective = {
  // \.{2,}
  componentUpdated: function (el, binding) {
    let reg = binding.value ? binding.value.reg : /[^0-9.]/ // 获取要限制的正则 默认校验数字（包括小数）
    let grobalReg = new RegExp(reg, 'g')
    el.onkeypress = function (e) {
      // console.log(1)
      let event = e || window.event
      let code = event.charCode
      if (code !== 0) {
        if (String.fromCharCode(code).match(reg)) {
          return false
        }
      }
    }
    // el.onBlur = function (e) {
    //   console.log(1)
    //   let event = e || window.event
    //   // console.log(event)
    //   setTimeout(() => {
    //     event.target.value = event.target.value.replace(grobalReg, '')
    //   }, 30)
    // }
    // el.addEventListener('textInput', function (e) {
    //   let event = e || window.event
    //   event.target.value = event.target.value.replace(grobalReg, '')
    // })
    el.oninput = function (e) {
      let event = e || window.event
      // console.log(event)
      setTimeout(() => {
        event.target.value = event.target.value.replace(grobalReg, '')
      }, 30)
    }
    // el.addEventListener('compositionstart', function (e) {
    //   console.log(e)
    // })

    // el.addEventListener('compositonupdate', function (e) {
    //   console.log('update:' + e.data)
    // })

    // el.addEventListener('compositionend', function (e) {
    //   console.log('end:' + e.data)
    // })
  }
}

export default inputDirective
